module.exports = __webpack_public_path__ + "assets/GTAmerica-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Bold.woff
// module id = 996
// module chunks = 19